import { render } from "./HomeStudent.vue?vue&type=template&id=66d361fc"
import script from "./HomeStudent.vue?vue&type=script&lang=js"
export * from "./HomeStudent.vue?vue&type=script&lang=js"

import "./HomeStudent.vue?vue&type=style&index=0&id=66d361fc&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__